const FIXED_MODELS = new Set([
    "FIXED",
    "AWS_FIXED"
]);
export function resolveUnitOfBilling(pricingPolicy, pricingTerms) {
    const model = pricingPolicy?.Model?.toUpperCase();
    if (model) {
        return FIXED_MODELS.has(model) ? "FIXED" : "TIERED";
    }
    const hasTiers = Array.isArray(pricingTerms?.tiers) && pricingTerms.tiers.length > 0;
    return hasTiers ? "TIERED" : "FIXED";
}
